export default __webpack_public_path__ + "static/media/scdream1.793cf0e8.woff2";